// Application dependencies

import { AuthorisationProduct } from "@/interfaces/authorisation/authorisation.interfaces";

// Product Enums ---------------------------------------------------------------------------------------------------------------------------

export enum ProductFields {
  CreatedAt = "created_at",
  Id = "id",
  Name = "name",
  Title = "title",
  UpdatedAt = "updated_at",
}

// Product Constants -----------------------------------------------------------------------------------------------------------------------

export const PRODUCT_UNKNOWN_MESSAGE = "Unknown product";

// Product Interfaces ----------------------------------------------------------------------------------------------------------------------

export interface Product {
  [ProductFields.CreatedAt]: string | null;
  [ProductFields.Id]: number;
  [ProductFields.Name]: AuthorisationProduct;
  [ProductFields.Title]: string;
  [ProductFields.UpdatedAt]: string | null;
}

export interface ProductCrud {
  [ProductFields.Id]: number | null;
  [ProductFields.Name]: AuthorisationProduct;
  [ProductFields.Title]: string;
}

export interface ProductDetail {
  [ProductFields.CreatedAt]: string | null;
  [ProductFields.Id]: number;
  [ProductFields.Name]: AuthorisationProduct;
  [ProductFields.Title]: string;
  [ProductFields.UpdatedAt]: string | null;
}

export interface ProductNameTitle {
  [ProductFields.Id]: number;
  [ProductFields.Name]: AuthorisationProduct;
  [ProductFields.Title]: string;
}
